const safeJSONParse = (key: string) => {
  try {
    const parsed = JSON.parse(key);
    return parsed;
  } catch (e) {
    return {};
  }
};

export default safeJSONParse;
